
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[url]/[url1]/[url2]",
      function () {
        return require("private-next-pages/[url]/[url1]/[url2].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[url]/[url1]/[url2]"])
      });
    }
  